// removed by extract-text-webpack-plugin
module.exports = {"smallDeviceMax":"567px","mediumDeviceMin":"568px","mediumDeviceMax":"991px","largeDeviceMin":"992px","large_device_min_alt":"1350px","creditsPage":"src-containers-Credits-__Credits-module___creditsPage","creditsImage":"src-containers-Credits-__Credits-module___creditsImage","creditsRowContainer":"src-containers-Credits-__Credits-module___creditsRowContainer","mobileText":"src-containers-Credits-__Credits-module___mobileText"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Credits/Credits.module.css
// module id = 1102
// module chunks = 1